<template>
  <mdb-footer class="site-footer font-small pt-4 mt-4">
    <div class="footer-cover-fix"></div>
    <mdb-container>
      <mdb-row>
        <mdb-col sm="12" md="4" class="company-info">
          <p><span class="company-name">Amnehagen IT AB</span><br />
             <i class="fas fa-building mr-3"></i>559195-9746<br />
             <i class="fas fa-building mr-3"></i>(VAT) SE559195974601<br />
             Swedish Corporate Tax Card (F-Skatt)</p>
        </mdb-col>
        <mdb-col sm="12" md="4" class="company-contact">
          <p><i class="fas fa-envelope mr-3"></i> contact@amnehagenit.com<br />
             <i class="fas fa-phone mr-3"></i> +46(0) 723359559</p>
        </mdb-col>
        <mdb-col sm="12" md="4" class="company-address">
          <p><i class="fas fa-home mr-3"></i>Furumossen 1b<br />
                                             43347 Partille, Sweden</p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <hr />
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="6" class="company-copyright">
          <p>&copy; 2023 Copyright Amnehagen IT AB</p>
        </mdb-col>
        <mdb-col md="6" class="company-social">
          <div class="text-center text-md-right">
            <ul class="list-unstyled list-inline">
<!--               <li class="list-inline-item"><a class="btn-floating btn-sm rgba-white-slight mx-1"><i class="fab fa-facebook"></i></a></li> -->
<!--               <li class="list-inline-item"><a class="btn-floating btn-sm rgba-white-slight mx-1"><i class="fab fa-twitter"></i></a></li> -->
<!--               <li class="list-inline-item"><a class="btn-floating btn-sm rgba-white-slight mx-1"><i class="fab fa-google-plus"></i></a></li> -->
<!--               <li class="list-inline-item"><a class="btn-floating btn-sm rgba-white-slight mx-1"><i class="fab fa-linkedin-in"></i></a></li> -->
            </ul>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </mdb-footer>
</template>

<script>
import {
  mdbFooter,
  mdbContainer,
  mdbRow,
  mdbCol
} from 'mdbvue'

export default {
  name: 'SiteFooter',
  props: {
    
  },
  components: {
    mdbFooter,
    mdbContainer,
    mdbRow,
    mdbCol
  }
}
</script>

<style scoped>
.footer-cover-fix {
  width: 100%;
  height: 25px;
  margin-top: -48px;
  background-color: #666666;
/*   border: 1px solid red; */
}

.site-footer {
  background-color: #666666;
  padding-top: 25px;
}

.company-name {
  font-weight: bold;
}

.company-info {
  text-align: left;
}


.company-contact {
  text-align: center;
}

.company-address {
  text-align: right;

}

.company-copyright {
  text-align: left;

}

.company-social {}

@media (max-width: 768px) {
  .company-contact {
    text-align: left;
  }
  
  .company-address {
    text-align: left;
  
  }
  
  .company-copyright {
    text-align: left;
  
  }
  
  .company-social {}
}
</style>